import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AutoTranslateDirective } from 'app/shared/directives/auto-translate.directive';
import { AutoTranslatePipe } from 'app/shared/pipes/translate.pipe';
import {
    ALLOCATION_MULTI_COMPANY_ACTION_LABELS,
    AllocationMultiCompanyDialogData,
    AllocationMultiCompanyDialogResult,
    AllocationMultiCompanyOption,
} from './allocation-multi-company.types';

@Component({
    selector: 'app-allocation-multi-company-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        AutoTranslateDirective,
        AutoTranslatePipe,
    ],
    templateUrl: './allocation-multi-company-dialog.component.html',
    styleUrls: ['./allocation-multi-company-dialog.component.scss'],
})
export class AllocationMultiCompanyDialogComponent {
    readonly actionLabel: string;
    readonly options: AllocationMultiCompanyOption[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: AllocationMultiCompanyDialogData,
        private dialogRef: MatDialogRef<AllocationMultiCompanyDialogComponent, AllocationMultiCompanyDialogResult>,
    ) {
        this.dialogRef.addPanelClass('card-dialog');
        this.actionLabel = ALLOCATION_MULTI_COMPANY_ACTION_LABELS[data.action];
        this.options = (data.companies || []).map((c) => ({
            company_id: c.company_id,
            name: c.name,
            selected: data.currentCompanyId != null && c.company_id === data.currentCompanyId,
            locked: data.currentCompanyId != null && c.company_id === data.currentCompanyId,
        }));
    }

    get canConfirm(): boolean {
        return this.options.some((o) => o.selected);
    }

    cancel(): void {
        this.dialogRef.close({ mode: 'cancel' });
    }

    confirm(): void {
        const companyIds = this.options.filter((o) => o.selected).map((o) => o.company_id);
        if (!companyIds.length) return;
        this.dialogRef.close({ mode: 'confirm', companyIds });
    }
}
